import { useUserAuth } from "../context/UserContext";

export const roles = {
  powerUser: 'powerUser',
  reviewer: 'reviewer',
  customerService: 'customerService',
  caSouthArea: "caSouthArea",
  sales: "sales",
  admin: "admin",
  d2c: "d2c",
};

export const permissionsMenu = {
  MENU_ORDERS: 'MENU_ORDERS',
  MENU_DASHBOARD: "MENU_DASHBOARD",
  MENU_CONFIGS: "MENU_CONFIGS",
  MENU_LOGS: "MENU_LOGS",
  MENU_USERS: "MENU_USERS",
  MENU_ROLES: "MENU_ROLES",
  MENU_TEMPLATES: "MENU_TEMPLATES",
  MENU_LOCALFILES: "MENU_LOCALFILES",
  MENU_SINGEL_ORDER: "MENU_SINGEL_ORDER",
  MENU_CREDIT_NOTE: "MENU_CREDIT_NOTE",
  MENU_D2C_ORDER_CREATE: "MENU_D2C_ORDER_CREATE",
};

export const permissions = {
  UPDATE_USER: "UPDATE_USER",
  UPLOAD_ORDER_FILE_BUTTON: 'UPLOAD_ORDER_FILE_BUTTON',
  DELETE_CREDIT_NOTE: 'DELETE_CREDIT_NOTE',
  UPLOAD_CREDIT_NOTE_FILE_BUTTON: 'UPLOAD_CREDIT_NOTE_FILE_BUTTON',
  UPDATE_ORDER: "UPDATE_ORDER",
  DELETE_ORDER: "DELETE_ORDER",
  GENERATE_RPA_FILES: "GENERATE_RPA_FILES",
  UPLOAD_TEMPLATE: "UPLOAD_TEMPLATE",
  DELETE_TEMPLATE: "DELETE_TEMPLATE",
  CREATE_LOCAL_FILE: "CREATE_LOCAL_FILE",
  UPDATE_LOCAL_FILE: "UPDATE_LOCAL_FILE",
  CREATE_D2C_ORDER: "CREATE_D2C_ORDER",
  GENERATE_CREDIT_NOTE_RPA_FILES: "GENERATE_CREDIT_NOTE_RPA_FILES",
};

export const rolePermissionsMap = {
  [roles.admin]: [
    //menu
    permissionsMenu.MENU_LOGS,
    permissionsMenu.MENU_DASHBOARD,
    permissionsMenu.MENU_USERS,
    permissionsMenu.MENU_ROLES,
    permissionsMenu.MENU_ORDERS,
    permissionsMenu.MENU_SINGEL_ORDER,
    permissionsMenu.MENU_TEMPLATES,
    permissionsMenu.MENU_LOCALFILES,
    permissionsMenu.MENU_D2C_ORDER_CREATE,
    permissionsMenu.MENU_CREDIT_NOTE,
    //actions
    permissions.UPLOAD_ORDER_FILE_BUTTON,,
    permissions.UPDATE_ORDER,
    permissions.DELETE_ORDER,
    permissions.DELETE_CREDIT_NOTE,
    permissions.GENERATE_RPA_FILES,
    permissions.UPLOAD_TEMPLATE,
    permissions.DELETE_TEMPLATE,
    permissions.CREATE_LOCAL_FILE,
    permissions.UPDATE_LOCAL_FILE,
    permissions.CREATE_D2C_ORDER,
    permissions.UPLOAD_CREDIT_NOTE_FILE_BUTTON,
    permissions.GENERATE_CREDIT_NOTE_RPA_FILES,
    permissions.UPDATE_USER,
  ],
  [roles.powerUser]: [
     //menu
    permissionsMenu.MENU_LOGS,
    permissionsMenu.MENU_DASHBOARD,
    permissionsMenu.MENU_USERS,
    permissionsMenu.MENU_ROLES,
    permissionsMenu.MENU_ORDERS,
    permissionsMenu.MENU_SINGEL_ORDER,
    permissionsMenu.MENU_TEMPLATES,
    permissionsMenu.MENU_LOCALFILES,
    permissionsMenu.MENU_CREDIT_NOTE,
    //actions
    permissions.UPLOAD_ORDER_FILE_BUTTON,
    permissions.UPDATE_ORDER,
    permissions.DELETE_ORDER,
    permissions.DELETE_CREDIT_NOTE,
    permissions.GENERATE_RPA_FILES,
    permissions.UPLOAD_TEMPLATE,
    permissions.DELETE_TEMPLATE,
    permissions.CREATE_LOCAL_FILE,
    permissions.UPDATE_LOCAL_FILE,
    permissions.UPLOAD_CREDIT_NOTE_FILE_BUTTON,
    permissions.GENERATE_CREDIT_NOTE_RPA_FILES,
    permissions.UPDATE_USER,
  ],
  [roles.customerService]: [
     //menu
    permissionsMenu.MENU_ORDERS,
    permissionsMenu.MENU_LOGS,
    permissionsMenu.MENU_DASHBOARD,
    permissionsMenu.MENU_TEMPLATES,
    //actions
    permissions.UPLOAD_ORDER_FILE_BUTTON,
    permissions.GENERATE_RPA_FILES,
    permissions.UPDATE_ORDER,
    permissions.UPLOAD_TEMPLATE,
    permissions.DELETE_TEMPLATE,
    permissions.DELETE_ORDER,
    permissions.DELETE_CREDIT_NOTE,
    permissions.GENERATE_CREDIT_NOTE_RPA_FILES,
  ],
  [roles.caSouthArea]: [
     //menu
    permissionsMenu.MENU_ORDERS,
    permissionsMenu.MENU_DASHBOARD
  ],
  [roles.sales]: [
     //menu
    permissionsMenu.MENU_ORDERS,
    permissionsMenu.MENU_DASHBOARD
  ],
  [roles.reviewer]: [
     //menu
    permissionsMenu.MENU_ORDERS,
    permissionsMenu.MENU_DASHBOARD,
  ],
  [roles.d2c]: [
     //menu
    permissionsMenu.MENU_D2C_ORDER_CREATE,
    permissionsMenu.MENU_ORDERS,
    permissionsMenu.MENU_DASHBOARD,
    permissionsMenu.MENU_LOGS,
     //actions
    permissions.UPLOAD_ORDER_FILE_BUTTON,
    permissions.DELETE_ORDER,    
    permissions.UPDATE_ORDER
  ],
};

export const hasPermission = (userRole: any, permission: any) => {
  return rolePermissionsMap[userRole]?.includes(permission);
};

export const Can = ({ permission, children }: { permission: any, children: any }) => {
  const { user } = useUserAuth();
  return hasPermission(user.roleCode, permission) ? children : null;
}


export const checkIfRoleHasRights = (userRoleCode: any, groupRoles: any) => {
  let userHasRights = groupRoles.includes(userRoleCode);
  if (userHasRights) {
    return true;
  }
  else {
    return false;
  }
}

export const adminGroup = (curentUserData: any) => {
  let groupRoles = [roles.powerUser, roles.admin]
  if (curentUserData) {
    return checkIfRoleHasRights(curentUserData.roleCode, groupRoles);
  }
}